import { render, staticRenderFns } from "./StockDayChange.vue?vue&type=template&id=3387e974&scoped=true&"
import script from "./StockDayChange.vue?vue&type=script&lang=js&"
export * from "./StockDayChange.vue?vue&type=script&lang=js&"
import style0 from "./StockDayChange.vue?vue&type=style&index=0&id=3387e974&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3387e974",
  null
  
)

export default component.exports